import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getVehiculesBrands, getVehiculesModels } from './ExternSearchServices';
import { makeSelectVehiculesBrands } from './selectors';
import { setVehiculesBrands } from './tecdocSlice';

const useVehiculesCriteria = () => {
  const [models, setModels] = useState([]);
  const [enginesCode, setEnginesCode] = useState([]);
  const [enginesType, setEnginesType] = useState([]);
  const [wasFetched, setWasFetched] = useState(false);
  const brands = useSelector(makeSelectVehiculesBrands());
  const dispatch = useDispatch();

  const fetchBrands = async () => {
    setWasFetched(true);
    const rep = await getVehiculesBrands();
    dispatch(setVehiculesBrands(rep));
  };

  const fetchModels = async (brandId) => {
    const rep = await getVehiculesModels(brandId);
    setModels(rep);
  };

  // when => valuesExtraVin.brand===null||vehicules[0].manuId != valuesExtraVin.brand.id
  // then check all vehicules.manuId are same
  // then set vehicules[0].manuId into valuesExtraVin.brand
  const updateBrandEngineCodeTypeIfNeeded = (currentBrand, vehicules, onChange) => {
    // Check if valuesExtraVin.brand is null or if manuId of
    // the first vehicle is different from the brand's id
    if (vehicules.length === 0) {
      console.log('reset');
      setEnginesType([]);
      setEnginesCode([]);
      onChange({ target: { name: 'brand', value: null } });
      setModels([]);
      return;
    }
    if (currentBrand === null || vehicules[0].manuId !== currentBrand.id) {
      // Check if all manuIds in vehicules are the same
      const allSameManuId = vehicules.every((vehicle) => vehicle.manuId === vehicules[0].manuId);

      if (allSameManuId) {
        // Set the manuId of the first vehicle into valuesExtraVin.brand
        const targetBrand = brands.find((b) => b.id === vehicules[0].manuId) || null;
        onChange({ target: { name: 'brand', value: targetBrand } });
        if (targetBrand) {
          fetchModels(targetBrand.id);
        }
      }
    }
    // Extract unique engineType/engineCode values
    setEnginesType([...new Set(vehicules.map((vehicle) => vehicle.engineType))]);

    setEnginesCode([...new Set(vehicules.map((vehicle) => (
      { name: vehicle.engineCode, type: vehicle.engineType }
    )))]);
  };

  useEffect(() => {
    if (brands.length > 0 || wasFetched) {
      return;
    }
    fetchBrands();
  }, [brands]);

  return {
    brands, models, enginesCode, enginesType, fetchModels, updateBrandEngineCodeTypeIfNeeded,
  };
};

export default useVehiculesCriteria;
